"use client";

import {JSX} from "react";

import {useRouter} from "next/navigation";

import {clearTripSession} from "@/entities/trip";

import {useTranslation} from "@/shared/i18n";
import {ButtonBase} from "@/shared/ui/buttons";
import {routes} from "@/shared/utils";

import "./styles/trip-logout-button.scss";

export function TripLogoutButton(): JSX.Element {
    const {t} = useTranslation();
    const router = useRouter();

    const handleLogout = (): void => {
        clearTripSession();
        router.push(routes.trip.list.url());
    };

    return (
        <ButtonBase variant="secondary-outline" size="sm" className="trip-logout-button" onClick={handleLogout}>
            {t("trip.logOut")}
        </ButtonBase>
    );
}
